// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__2C6dL","info":"UpdateTermsInfo_info__x4XcC"};